import React, { useCallback, useEffect, useState } from "react";
import axios from 'axios';
import PropTypes from "prop-types";
import { Icon } from "@iconify/react";
import menu2Fill from "@iconify/icons-eva/menu-2-fill";
// material
import { alpha, styled } from "@mui/material/styles";
import { Box, Stack, AppBar, Toolbar, IconButton, Badge, Select, MenuItem } from "@mui/material";
// components
import AccountPopover from "./AccountPopover";
import Notification from "../../assets/icons/icon_notification.svg";
import Search from "../../assets/icons/icon_search_header.svg";
import Headerlogo from "../../assets/img/header-logo.jpg";
import { DecryptData, EncryptData } from "../../utils/encryptDecrypt";
import { getToken } from "../../config/services/token";
import { toast } from "react-hot-toast";
// ----------------------------------------------------------------------

const DRAWER_WIDTH = 182;
const APPBAR_MOBILE = 64;
const APPBAR_DESKTOP = 80;

const RootStyle = styled(AppBar)(({ theme }) => ({
  boxShadow: "none",
  backdropFilter: "blur(6px)",
  WebkitBackdropFilter: "blur(6px)", // Fix on Mobile
  backgroundColor: alpha(theme.palette.background.default, 0.72),
  [theme.breakpoints.up("lg")]: {
    width: `calc(100% - ${DRAWER_WIDTH + 1}px)`,
  },
}));

const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
  minHeight: APPBAR_MOBILE,
  [theme.breakpoints.up("lg")]: {
    minHeight: APPBAR_DESKTOP,
    padding: theme.spacing(0, 5),
  },
}));

// ----------------------------------------------------------------------

DashboardNavbar.propTypes = {
  onOpenSidebar: PropTypes.func,
};

export default function DashboardNavbar({ onOpenSidebar }) {
  const [selectedRole,setSelectedRole] = useState(DecryptData(localStorage.getItem('uuid')))
  const [role,setRole] = useState(DecryptData(localStorage.getItem('role')))
  const [roles,setRoles] = useState(JSON.parse(DecryptData(localStorage.getItem('crmRoles'))))

  const handleRoleChange = useCallback((event) => {
      const value = event.target.value      
      getToken({uuid:value,role})
        .then(
          res => {
            let tokenObj = res.data
            setSelectedRole(value)
            localStorage.setItem('uuid',EncryptData(value))
            //console.log(tokenObj)
            localStorage.setItem('accessToken', tokenObj.token)
            axios.defaults.headers.common['accessToken'] = tokenObj.token;
            if (tokenObj.cubeToken) {
              localStorage.setItem('cubeToken', tokenObj.cubeToken)
            }
            if (tokenObj.menusAllowed) {
              localStorage.setItem('menusAllowed', EncryptData(JSON.stringify(tokenObj.menusAllowed)))
            } else {
              localStorage.removeItem('menusAllowed')
            }
          }
        )
        .catch(
          (err) => {
            toast.error('Something went wrong, while fetching the Role details')
          }
        )
  })
  return (
    <RootStyle>
      <ToolbarStyle className="main-header">
        <Stack
          direction="row"
          alignItems="center"
          spacing={{ xs: 0.5, sm: 1.5 }}
        >
          <IconButton
            onClick={onOpenSidebar}
            sx={{ mr: 1, color: "text.primary" }}
            className="mob-menu"
          >
            <Icon icon={menu2Fill} />
          </IconButton>
          <div className="appHeader_left">
            {/* <div className="appHeader_logo">
              <img src={Headerlogo} alt="logo" className="img-fluid" />
            </div>
            <div>
              <h2 className="text-50 fw-600">Delhi Public School </h2>
              <p>Sector 30, Noida Uttar Pradesh - 201303</p>
            </div> */}
          </div>
        </Stack>
        <Box sx={{ flexGrow: 1 }} />
        <Stack
          direction="row"
          alignItems="center"
          spacing={{ xs: 0.5, sm: 1.5 }}
        >
          <div className="appHeader_right">
            {/* <ul className="list-inline">
              <li className="list-inline-item">
                <img src={Notification} alt="notification" />
              </li>
              <li className="list-inline-item">
                <img src={Search} alt="search" />
              </li>
            </ul> */}
            {/* <Badge className="report_header_notifiction" badgeContent={`0`} color="primary" >
              <img src={Notification} alt="notification" />
            </Badge> */}
            {
              roles && roles.length > 1 &&
              <Select
                value={selectedRole ?? null}
                onChange={handleRoleChange}
              >
                {
                  roles.map(obj => (
                    <MenuItem key={`crm-role-${obj}`} value={obj}>{obj}</MenuItem>
                  ))
                }
              </Select>
            }
            
          </div>
          <AccountPopover />
        </Stack>
      </ToolbarStyle>
    </RootStyle>
  );
}
